import { default as MuiDialog, DialogProps } from '@mui/material/Dialog'

const Dialog = (props: DialogProps) => {
  return <MuiDialog {...props} />
}

export default Dialog
